export const ShipmentTipsEndpoint = (makeRequest) => {
    return {
        fetchShipmentTipsForUser(params, options) {
            return makeRequest('GET', '/courier_tips/shipment_tips', params, options);
        },
        createShipmentTip(params, options) {
            return makeRequest('POST', '/courier_tips/shipment_tips', params, options);
        },
        updateShipmentTip(params, options) {
            return makeRequest('PUT', `/courier_tips/shipment_tips/${params.id}`, params, options);
        },
    };
};
//# sourceMappingURL=shipment_tips_endpoint.js.map